import { render, staticRenderFns } from "./last_news.vue?vue&type=template&id=db5630fc&"
import script from "./last_news.vue?vue&type=script&lang=js&"
export * from "./last_news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports